let expandableTableCounter = 0;

function addTableExpandButtons(container = document) {
	const expandText = Liferay.Language.get(
		"kafi3-article-table-button-expand-table"
	);
	const collapseText = Liferay.Language.get(
		"kafi3-article-table-button-collapse-table"
	);

	const tables = container.querySelectorAll(".table-responsive");

	tables.forEach((table) => {
		table.setAttribute("tabindex", "0");
		if (table.dataset.expandButtonAdded) return;
		const hasHorizontalScroll = table.scrollWidth > table.clientWidth;
		if (!hasHorizontalScroll) return;
		if (window.innerWidth <= 992) return;
		if (!table.id) {
			table.id = `expandable-table-${expandableTableCounter++}`;
		}

		const button = document.createElement("button");
		button.type = "button";
		button.setAttribute("aria-controls", table.id);
		button.setAttribute("aria-label", expandText);
		button.setAttribute("aria-expanded", "false");
		button.textContent = expandText;
		button.style.marginTop = "1rem";
		button.style.marginBottom = "1rem";
		button.style.display = "inline-block";
		button.classList.add("kds-btn", "kds-btn--outline", "kds-btn--dark");

		table.insertAdjacentElement("afterend", button);
		table.dataset.expandButtonAdded = "true";

		let expanded = false;
		button.addEventListener("click", function () {
			expanded = !expanded;
			table.style.overflow = expanded ? "visible" : "auto";
			const text = expanded ? collapseText : expandText;
			button.textContent = text;
			button.setAttribute("aria-label", text);
			button.setAttribute("aria-expanded", expanded.toString());
		});
	});
}
document.addEventListener("DOMContentLoaded", () => {
	addTableExpandButtons();

	document
		.querySelectorAll(".accordion__header a, .accordion__header")
		.forEach((header) => {
			header.addEventListener("click", () => {
				setTimeout(() => {
					addTableExpandButtons(header.closest(".accordion"));
				}, 0);
			});
		});
});
